import { fallback, maxValue, minValue, number, pipe } from "valibot"

export const PERSPECTIVE_CAMERA_FOV_STEP: number = 5
export const PERSPECTIVE_CAMERA_FOV_MIN: number = 10
export const PERSPECTIVE_CAMERA_FOV_MAX: number = 175
export const PERSPECTIVE_CAMERA_FOV_DEFAULT: number = 30

export const CameraFovSchema = fallback(pipe(number(),
  minValue(PERSPECTIVE_CAMERA_FOV_MIN),
  maxValue(PERSPECTIVE_CAMERA_FOV_MAX),
), PERSPECTIVE_CAMERA_FOV_DEFAULT)
